export var LoadState;
(function (LoadState) {
    LoadState["None"] = "NONE";
    LoadState["Loading"] = "LOADING";
    LoadState["Finished"] = "FINISHED";
    LoadState["Failed"] = "FAILED";
})(LoadState || (LoadState = {}));
//# sourceMappingURL=load-state.type.js.map